<!-- 
화면명 : UndeliveredList.vue
작성일 : 2025-07-01
설명   : 미납현황 화면
-->
<template>
  <div class="relative bg-blueGray-100">
    <div class="flex justify-between mt-2">
      <div class="flex text-black font-bold text-lg items-center justify-center">
        <img src="@/assets/img/breadcrumbs.svg" class="w-4 h-4 mx-2" />
        미납현황
      </div>
      <div class="flex mx-2">
        <UCButton label="조회" width="80px" icon="search" @click="btnSearchClick" />
        <UCButton label="엑셀" width="80px" icon="excel" @click="btnExcelClick" />
        <UCButton label="출력" width="80px" icon="printer" @click="btnIlboClick"/>
        <UCButton label="발주서" width="100px" icon="printer" @click="btnMBClick" />
      </div>
    </div>

    <div class="bg-white p-1 rounded shadow mt-2 top-wrapper">
      <!-- <div class="flex text-blueGray-700 font-bold text-lg mb-4">
        <img src="@/assets/img/icon-search.svg" class="w-7 h-7" />
        조회 조건
      </div> -->

      <div
        class="w-full overflow-x-visible inline-flex flex-wrap items-center gap-6 whitespace-nowrap px-4 py-2 border rounded bg-white shadow-sm"
      >
        <div class="flex space-x-2">
          <UCDate label="발주일자" v-model="dtStart" />
          <span class="pt-2">&nbsp;~</span>
          <UCDate label="" v-model="dtEnd" />
        </div>

        <UCRadio
          label="작업구분"
          v-model="rdoGubun.cd"
          :arrData="rdoGubun.arr"
          code="value"
          name="label"
        />

        <div class="flex items-center space-x-2">
          <UCVendor
            title="거래선"
            :VendCd="userStore.userVendCd"
            :VendName="userStore.userName"
          />
        </div>

        <UCCombo
          label="발주구분"
          v-model="cboBaljuGubun.cd"
          :arrData="cboBaljuGubun.arr"
          code="CD"
          name="NAME"
          width="190px"
        />
      </div>
    </div>

    <!-- 소계 구분 -->
    <div class="mt-2 flex justify-between items-center">
      <label class="flex text-blueGray-600 text-base font-semibold whitespace-nowrap items-center justify-center" >
        <img src="@/assets/img/icon-list.svg" class="flex w-5 h-5 mr-2" />
        미입고 대상 리스트
      </label>

      <UCButton
        class="flex justify-end"
        label="예상납기일 저장"
        icon="save"
        width="160px"
        @click="btnSaveForDateClick"
      />
    </div>

    <!-- 그리드 -->
    <div class="mt-2 mb-2 flex-1">
      <UCGrid
        :data="arrSearchData"
        :isRowNumber="true"
        :columns="columns"
        :options="gridOptions"
        :selectable="true"
        :pagination="true"
        :paginationSize="50"
        autoHeight
        :excludeSelectors="['.top-wrapper']"
        :heightOffset="30"
        @row-selected="handleSelection"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { format as formatDate } from "date-fns";
import { notify } from "@kyvg/vue3-notification";

import { useUserStore } from "@/store/userStore";
import { saveAs } from "file-saver";
import ExcelJS from "exceljs";

import UCVendor from "@/components/UserControl/UCVendor.vue";
import UCGrid from "@/components/UserControl/UCGrid.vue";
import UCText from "@/components/UserControl/UCText.vue";
import UCCombo from "@/components/UserControl/UCCombo.vue";
import UCDate from "@/components/UserControl/UCDate.vue";
import UCRadio from "@/components/UserControl/UCRadio.vue";
import UCButton from "@/components/UserControl/UCButton.vue";

import { apiExecuteDataSet, apiExecuteReport, apiExecuteNonQuery, apiExecuteMultiNonQuery } from "@/api/SCM/common";

const userStore = useUserStore();

onMounted(() => {
  // console.log("mounted");

  bindCombo();

  btnSearchClick();
});

// 처리 구분
const rdoGubun = ref({
  cd: "1",
  arr: [
    { label: "자재", value: "1" },
    { label: "외주", value: "2" },
  ],
});

const dtStart = ref("");
const dtEnd = ref("");

// 소계 구분
const rdoSubTotalGubun = ref({
  cd: "TOTAL",
  arr: [
    { label: "전체", value: "TOTAL" },
    { label: "발주일자별", value: "ORDDT" },
    { label: "입고일자별", value: "IPGDT" },
  ],
});

// 발주구분
const cboBaljuGubun = ref({
  cd: "",
  arr: [
    { NAME: "전체", CD: "" },
    { NAME: "1원 단가", CD: "T" },
  ],
});

async function bindCombo() {
  // console.log("bindCombo");

  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth();

  const today2 = new Date(year, month, 1);
  dtStart.value = formatDate(today2, "yyyy-MM-dd");
  dtEnd.value = formatDate(today, "yyyy-MM-dd");
}

async function btnSearchClick() {
  // console.log("btnSearchClick", rdoSubTotalGubun.value.cd);

  if (!dtStart.value || !dtEnd.value) {
    notify({
      title: "경고",
      text: "조회 기간을 입력해주세요.",
      type: "error",
    });
    return;
  }

  const startDate = new Date(dtStart.value);
  const endDate = new Date(dtEnd.value);
  const maxDate = new Date(startDate);
  maxDate.setFullYear(maxDate.getFullYear() + 1);

  if (endDate > maxDate) {
    notify({
      title: "경고",
      text: "최대 1년기간 내 자료만 조회가능합니다",
      type: "error",
    });
    return;
  }

  const searchParams = {
    
    ID: "WERP\\T_MT05ORDR\\R010",
    Parameter: {
      "@FM05ORDDATE": dtStart.value.replaceAll("-", ""),
      "@TM05ORDDATE": dtEnd.value.replaceAll("-", ""),
      "@M05CUSNO": userStore.userVendCd,
      "@SGU1": rdoGubun.value.cd,
      "@ONEDANGA": cboBaljuGubun.value.cd,

      "@PAGENO": 1,
      "@PAGEINROW": 10000,
      "@SIDX": null,
      "@SORD": null,
      "@CURPAGE": null,
      "@MAXPAGE": null,
      "@TOTALCOUNT": null,
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  // console.log("res", res._Result);

  arrSearchData.value = res._Result[0];
}

const arrSearchData = ref([]);
const selectedRows = ref([]);
function handleSelection(data) {
  selectedRows.value = data;
  console.log("선택된 행:", data);
}

// 날짜 에디터 함수
function dateEditor(cell, onRendered, success, cancel) {
  let cellValue = cell.getValue() || "";
  const s = String(cellValue).replace(/[^0-9]/g, "");
  if (s.length === 8) {
    cellValue = `${s.substring(0, 4)}-${s.substring(4, 6)}-${s.substring(6, 8)}`;
  }

  const input = document.createElement("input");
  input.type = "date";
  input.value = cellValue;
  input.className =
    "w-full h-full text-center border border-blue-500 rounded px-1 text-sm bg-white focus:outline-none shadow-inner";
  input.style.boxSizing = "border-box";

  onRendered(function () {
    input.focus();
    if (typeof input.showPicker === "function") {
      try {
        input.showPicker();
      } catch (e) {
        console.warn("showPicker error:", e);
      }
    }
  });

  function onChange() {
    const rawVal = input.value;
    if (rawVal !== cellValue) {
      const formatted = rawVal.replace(/-/g, "");
      success(formatted);
      // 값 변경 시 해당 행 자동 체크 선택
      cell.getRow().select();
    } else {
      cancel();
    }
  }

  input.addEventListener("change", onChange);
  input.addEventListener("blur", onChange);
  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      onChange();
    } else if (e.key === "Escape") {
      cancel();
    }
  });

  return input;
}

const gridOptions = {
  selectableCheck: function (row) {
    const data = row.getData();
    const ordKey = data?.M05ORDKEY ? String(data.M05ORDKEY).trim() : "";
    const matCd = data?.M05MATCD ? String(data.M05MATCD).trim() : "";
    return (
      !ordKey.includes("소계") &&
      !ordKey.includes("총계") &&
      !matCd.includes("소계") &&
      !matCd.includes("총계")
    );
  },
  rowFormatter: function (row) {
    const data = row.getData();
    const ordKey = data?.M05ORDKEY ? String(data.M05ORDKEY).trim() : "";
    const matCd = data?.M05MATCD ? String(data.M05MATCD).trim() : "";
    const element = row.getElement();

    if (
      ordKey.includes("소계") ||
      ordKey.includes("총계") ||
      matCd.includes("소계") ||
      matCd.includes("총계") ||
      (ordKey && ordKey.length !== 12 && matCd === "")
    ) {
      element.style.backgroundColor = "#fef9c3";
      element.style.fontWeight = "bold";
      element.style.color = "#0f172a";

      const chk = element.querySelector("input[type='checkbox']");
      if (chk) {
        chk.style.display = "none";
      }
    } else {
      element.style.backgroundColor = "";
      element.style.fontWeight = "";
      element.style.color = "";

      const chk = element.querySelector("input[type='checkbox']");
      if (chk) {
        chk.style.display = "";
      }
    }
  },
};

const columns = [
  {
    title: "",
    formatter: "rowSelection",
    titleFormatter: "rowSelection",
    hozAlign: "center",
    headerSort: false,
    width: 50,
    frozen: true,
  },
  { title: "발주번호", field: "M05ORDKEY", width: 120, hozAlign: "center", frozen: true},
  { field: "M05MATCD", width: 100, title: "자재코드" , hozAlign: "center", frozen: true },
  { title: "자재명", field: "M05MATNA", width: 120, hozAlign: "left", frozen: true },
  { title: "도면번호", field: "M05DWGNO", width: 120, hozAlign: "left" },

  { field: "M05SIZE", width: 90, title: "규격", hozAlign: "left" },
  { field: "M05MATL", width: 110, title: "재질" , hozAlign: "left" },
  { field: "M05UNIT", width: 40, title: "단위" , hozAlign: "center" },
  { field: "M05ORDQTY", width: 80, title: "발주" , hozAlign: "right" ,
        formatter: "money",
        formatterParams: {
          thousand: ",",
          precision: 0,
        },},
  { field: "M05IPGQTY", width: 80, title: "입고" , hozAlign: "right",
        formatter: "money",
        formatterParams: {
          thousand: ",",
          precision: 0,
        }, },
  { field: "M05MIPQTY", width: 80, title: "미납" , hozAlign: "right",
        formatter: "money",
        formatterParams: {
          thousand: ",",
          precision: 0,
        }, },
  { field: "M05DEVDATE", width: 100, title: "납기일자", hozAlign: "center" },

  {
    field: "FORDATE",
    width: 120,
    title: "예상납기일",
    hozAlign: "center",
    editor: dateEditor,
    editable: function (cell) {
      const data = cell.getRow().getData();
      const ordKey = data?.M05ORDKEY ? String(data.M05ORDKEY).trim() : "";
      return !ordKey.includes("소계") && !ordKey.includes("총계");
    },
    formatter: function (cell) {
      const data = cell.getRow().getData();
      const ordKey = data?.M05ORDKEY ? String(data.M05ORDKEY).trim() : "";
      if (ordKey.includes("소계") || ordKey.includes("총계")) {
        return "";
      }

      const val = cell.getValue();
      let dateText = "";
      if (val) {
        const s = String(val).replace(/[^0-9]/g, "");
        if (s.length === 8) {
          dateText = `${s.substring(0, 4)}-${s.substring(4, 6)}-${s.substring(6, 8)}`;
        } else {
          dateText = val;
        }
      }

      return `
        <div class="flex items-center justify-between w-full h-full px-1 cursor-pointer">
          <span class="text-blue-600 font-semibold flex-1 text-center">${dateText}</span>
          <span class="text-blueGray-400 text-xs select-none">📅</span>
        </div>
      `;
    },
  },
  { field: "DEVDATE_P", width: 100, title: "이전납기" , hozAlign: "center" },

  { field: "M05DANGA", width: 100, title: "단가" , hozAlign: "right" ,
        formatter: "money",
        formatterParams: {
          thousand: ",",
          precision: 0,
        },},
  { field: "M05AMOUNT", width: 100, title: "금액" , hozAlign: "right" ,
        formatter: "money",
        formatterParams: {
          thousand: ",",
          precision: 0,
        },},
  { field: "M05INSCOND", width: 100, title: "검사", hozAlign: "center" },
  { field: "M05CHANGE", width: 70, title: "비고" , hozAlign: "center" },

  { field: "DEVNAME" , width: 95, title: "납품장소" , hozAlign: "left" },
  { field: "B05WORKNO" , width: 90, title: "호선명" , hozAlign: "left" },
  { field: "B05WORKNA" , width: 110, title: "엔진타입"  , hozAlign: "left" },
  { field: "B11HULL_NUM" , width: 90, title: "HULL넘버" , hozAlign: "left" },
  { field: "B11SHIP_YARD" , width: 90, title: "SHIP_YARD"  , hozAlign: "left" },
];

// 예상납기일 저장 목업 함수
async function btnSaveForDateClick() {
  // 1. 체크된 행 또는 예상납기일(FORDATE)이 입력된 행 추출
  let targetRows = [];

  if (selectedRows.value && selectedRows.value.length > 0) {
    targetRows = selectedRows.value.filter((row) => {
      const ordKey = row.M05ORDKEY ? String(row.M05ORDKEY).trim() : "";
      const forDate = row.FORDATE ? String(row.FORDATE).trim() : "";
      return ordKey && !ordKey.includes("소계") && !ordKey.includes("총계");
    });
  }

  if (targetRows.length === 0) {
    notify({
      title: "알림",
      text: "저장할 예상납기일 데이터가 없거나 유효한 행이 선택되지 않았습니다.\n예상납기일을 입력 후 저장해 주세요.",
      type: "warn",
    });
    return;
  }
  // MT05ORDR_UPDATEFORDATE
  const saveParams = targetRows.map((item) => ({
      ID: "WERP\\T_MT05ORDR\\U005",
      Parameter:{
      "@ORDKEY": item.M05ORDKEY.replaceAll("-", "") ,
      "@FORDATE": String(item.FORDATE).replace(/[^0-9]/g, ""), // YYYYMMDD
      "@CUSNO": userStore.userVendCd,
      "@SGU1": rdoGubun.value.cd,
      }
  }));
  console.log("=== [예상납기일 저장 데이터] ===", saveParams);
  try {
    const res = await apiExecuteMultiNonQuery(saveParams);
    if (res && res.Code == 200 && res.Message == "Y") {
      notify({
        title: "저장 완료",
        text: `총 ${saveParams.length}건의 예상납기일이 성공적으로 저장되었습니다.`,
        type: "success",
      });
    } else {
      const errMsg = res?.Message || "예상납기일 저장 중 오류가 발생했습니다.";
      notify({
        title: "오류",
        text: errMsg,
        type: "error",
      });
    }
    console.log('res', res);
  } catch (error) {
    console.error("예상납기일 저장 중 오류:", error);
    const errMsg =
      error.response?.data?.Message ||
      error.response?.data?.message ||
      error.Message ||
      error.message ||
      "예상납기일 저장 중 오류가 발생했습니다.";
    notify({
      title: "오류",
      text: errMsg,
      type: "error",
    });
  }
}

async function btnExcelClick() {
  // console.log("btnExcelClick");

  // 다시 조회를 해서 가져오는게 나을지 확인 -> 조회랑 데이터가 달라서 다시 조회
  const searchParams = {
    
    ID: "WERP\\T_MT05ORDR\\R011",
    Parameter: {
      "@SCUSNO": userStore.userVendCd,
      "@SFDT": dtStart.value.replaceAll("-", ""),
      "@STDT": dtEnd.value.replaceAll("-", ""),
      "@SGU1": rdoGubun.value.cd,
      "@ONEDANGA": cboBaljuGubun.value.cd,
    },
  };

  const res = await apiExecuteDataSet(searchParams);
  // console.log("res", res._Result);

  if (res._Result[0].length === 0) {
    notify({
      title: "실패",
      text: "조회된 데이터 건수가 없습니다.",
      type: "error",
    });
    return;
  }

  const templatePath = "/excel/미납리스트(자재).xlsx";
  const today = new Date();

  try {
    // 템플릿 파일 가져오기
    const response = await fetch(templatePath);
    const buffer = await response.arrayBuffer();

    // 워크북 로드
    const workbook = new ExcelJS.Workbook();
    await workbook.xlsx.load(buffer);

    // 첫 번째 워크시트 선택
    const worksheet = workbook.getWorksheet(1);

    // 데이터 바인딩
    const rdoGubunNm = rdoGubun.value.cd === "1" ? "자재" : "외주";

    worksheet.getCell("A1").value = `미납리스트 (${rdoGubunNm})`;

    worksheet.getCell("A2").value = `거래선 : ${
      userStore.userVendCd.substring(0, 3) +
      "-" +
      userStore.userVendCd.substring(4, 2) +
      "-" +
      userStore.userVendCd.substring(6)
    }`;

    worksheet.getCell("A3").value = `납기일자 : ${
      dtStart.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtStart.value.replaceAll("-", "").slice(6, 8)
    } 부터 ${
      dtEnd.value.replaceAll("-", "").slice(0, 4) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(4, 6) +
      "-" +
      dtEnd.value.replaceAll("-", "").slice(6, 8)
    } 까지`;
    worksheet.getCell("A4").value = `${
      rdoGubun.value.cd === "1" ? "자재" : "외주"
    }발주`;

    worksheet.getCell("AT2").value = `작성자 : ${userStore.userName}`;
    worksheet.getCell("AT3").value = `출력일자 :  ${formatDate(
      today,
      "yyyy-MM-dd"
    )}`;

    // 테이블 데이터 바인딩
    const startRow = 7; // 데이터가 시작될 행 번호 (예: 6번째 행부터 시작)
    res._Result[0].forEach((item, index) => {
      // console.log("forEach", index, item);

      const row = worksheet.getRow(startRow + index);
      row.getCell(1).value = item.발주번호;
      row.getCell(2).value = item.발주구분;
      row.getCell(3).value = item.자재코드;
      row.getCell(4).value = item.자재명;
      row.getCell(5).value = item.도면번호;
      row.getCell(6).value = item.규격;
      row.getCell(7).value = item.재질;
      row.getCell(8).value = item.단위;
      row.getCell(9).value = item.발주량;

      row.getCell(10).value = item.투입량;
      row.getCell(11).value = item.가입고;
      row.getCell(12).value = item.입고량;
      row.getCell(13).value = item.미납량;
      row.getCell(14).value = item.단가;
      row.getCell(15).value = item.공사번호;
      row.getCell(16).value = item.납기일;
      row.getCell(17).value = item.예정일;
      row.getCell(18).value = item.투입일;
      row.getCell(19).value = item.검사구분;

      row.getCell(20).value = item.검사구분명;
      row.getCell(21).value = item.긴급;
      row.getCell(22).value = item.PAINT;
      row.getCell(23).value = item.창고번호;
      row.getCell(24).value = item.금액;
      row.getCell(25).value = item.선급;
      row.getCell(26).value = item.황삭;
      row.getCell(27).value = item.열처리;
      row.getCell(28).value = item.절단;
      row.getCell(29).value = item.샤링;

      row.getCell(30).value = item.벤딩;
      row.getCell(31).value = item.사상;
      row.getCell(32).value = item.단조;
      row.getCell(33).value = item.SHIP_YARD;
      row.getCell(34).value = item.HULL_NUMBER;
      row.getCell(35).value = item.주문납기;
      row.getCell(36).value = item.납품장소;
      row.getCell(37).value = item.납품장소명;
      row.getCell(38).value = item.시작납기일;
      row.getCell(39).value = item.종료납기일;

      row.getCell(40).value = item.출력거래처번호;
      row.getCell(41).value = item.출력거래처명;
      row.getCell(42).value = item.TYPE;
      row.getCell(43).value = item.근거번호;
      row.getCell(44).value = item.구분;
      row.getCell(45).value = item.제품명;
      row.getCell(46).value = item.제품규격;
    });

    // 합계 데이터 바인딩
    // worksheet.getCell('D' + (startRow + dataToBind.salesData.length)).value = dataToBind.totalSales;

    // 변경된 워크북을 버퍼로 변환
    const excelBuffer = await workbook.xlsx.writeBuffer();

    // 파일을 Blob으로 만들고 다운로드
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `미납리스트(${rdoGubunNm})_${formatDate(today, "yyyyMMdd")}.xlsx`
    );

    notify({
      title: "성공",
      text: "엑셀 다운로드가 완료되었습니다.",
      type: "success",
    });
  } catch (error) {
    // console.error("엑셀 다운로드 중 오류 발생:", error);

    notify({
      title: "실패",
      text: "엑셀 다운로드에 실패했습니다." + error,
      type: "error",
    });
  }
}

//일보출력
async function btnIlboClick() {
  const searchParams = {
    
    ID: "W000\\W000\\R-OCM\\WY03PSR", 
    Parameter: {
      "@SCUSNO": userStore.userVendCd,
      "@SFDT": dtStart.value.replaceAll("-", ""),
      "@STDT": dtEnd.value.replaceAll("-", ""),
      "@SGU1": rdoGubun.value.cd,
      "@ONEDANGA": cboBaljuGubun.value.cd,
    },
  };

  const exportParams = {
    title: "미납현황",
    //width: 1100,
    //height: 900,
  };

  await apiExecuteReport(searchParams, exportParams);
}

let printPopupWin = null;

//발주서출력
async function btnMBClick() {
  // 그리드에서 체크/선택된 데이터 수집
  let items = [];
  if (selectedRows.value && selectedRows.value.length > 0) {
    items = selectedRows.value;
  } else if (arrSearchData.value && arrSearchData.value.length > 0) {
    items = arrSearchData.value.filter((row) => row.isCheck);
  }

  // 중복 POS 제거 및 최대 30개 추출
  const uniqueItems = [];
  const seenPos = new Set();
  for (const item of items) {
    if (item && item.M05ORDKEY && !seenPos.has(item.M05ORDKEY)) {
      seenPos.add(item.M05ORDKEY);
      uniqueItems.push({
        pos: item.M05ORDKEY,
        heatNo: item.M05HEATNO || "",
      });
      if (uniqueItems.length >= 30) break;
    }
  }

  const gbn = rdoGubun.value.cd ==='1'?'M' : 'P';
  const timestamp = Date.now();

  // localStorage에 저장 (창 간 storage 이벤트 트리거)
  localStorage.setItem(
    "print_order_items",
    JSON.stringify({ items: uniqueItems, gbn, timestamp })
  );

  const width = 1050;
  const height = 620;
  const left = Math.max(0, (window.screen.width - width) / 2);
  const top = Math.max(0, (window.screen.height - height) / 2);
  const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=no,toolbar=no,menubar=no,location=no`;

  // 팝업 열기 (timestamp 파라미터를 붙여 기존 창이 열려있어도 라우터 갱신 유도)
  printPopupWin = window.open(
    `/POPUP/print?gbn=${gbn}&t=${timestamp}`,
    "PrintMBWindow",
    windowFeatures
  );

  // 이미 열려있는 팝업창인 경우 postMessage로 데이터 즉시 반영 및 포커스
  if (printPopupWin) {
    printPopupWin.focus();
    printPopupWin.postMessage(
      {
        type: "UPDATE_PRINT_DATA",
        items: uniqueItems,
        gbn: gbn,
      },
      "*"
    );
  }
}
</script>
